import { message, Modal, Space } from "antd";
import styles from "./index.less";
import { ReactComponent as BalanceIcon } from "@/assets/images/balance.svg";
import { ReactComponent as RightOutlined } from "@/assets/images/right-arrow.svg";
import { ReactComponent as BankIcon } from "@/assets/images/bank.svg";
import { ReactComponent as AliPayIcon } from "@/assets/images/ali_pay.svg";
import { ReactComponent as WeixinIcon } from "@/assets/images/wechat_pay.svg";
import { useState } from "react";
import { getBalanceService, OrderInfo, PayType } from "@/services/order";
import { ResponseCode } from "@/constants";
import OfflinePayModal from "../OfflinePayModal";
import BalancePayModal from "../BalancePayModal";
import classNames from "classnames";
import WeChatPay from "../WechatPay";
import AliPay from "../AliPay";
import { useRequest } from "ahooks";

const allPayTypes = [
  PayType.BALANCE,
  PayType.WECHAT,
  PayType.ALIPAY,
  PayType.OFFLINE,
];

export interface PayModalProps {
  open: boolean;
  onSuccess: (payType: PayType) => void;

  onClose: () => void;
  orderInfo: OrderInfo;
}

export default function EnterprisePay(props: PayModalProps) {
  const supportPays = allPayTypes;

  const { open, onClose, orderInfo, onSuccess } = props;

  const [offlineModalOpen, setOfflineModalOpen] = useState(false);
  const [balancePayModalOpen, setBalancePayModalOpen] = useState(false);
  const [wechatPayModalOpen, setWechatPayModalOpen] = useState(false);
  const [aliPayModalOpen, setAliPayModalOpen] = useState(false);

  const { data: balance } = useRequest(
    async () => {
      if (!open) return;
      const rsp = await getBalanceService();
      if (rsp.code !== ResponseCode.Success) {
        message.error(rsp.msg);
      }
      return rsp.data;
    },
    { refreshDeps: [open] }
  );

  return (
    <>
      <Modal
        open={open}
        footer={null}
        maskClosable={false}
        onCancel={onClose}
        width={480}
      >
        <div className="flex justify-center items-end my-8">
          <div className="text-center">应付 </div>
          <div className="text-center text-accent font-bold">
            <span className="text-[#EC7057]"> ¥ </span>
            <span className="text-[#EC7057] font-[DIN] text-[32px] leading-none">
              {orderInfo.amount}
            </span>
          </div>
        </div>
        <div className="font-bold text-sm text-text-strong mb-3">支付方式</div>
        {supportPays?.includes(PayType.BALANCE) && (
          <div
            className={classNames(styles.item, {
              [styles["item-disabled"]]:
                orderInfo.amount > (balance?.canUseBalance || 0),
            })}
            onClick={() => setBalancePayModalOpen(true)}
          >
            <Space>
              <BalanceIcon
                className={`${styles.icon} ${
                  orderInfo.amount <= (balance?.canUseBalance || 0)
                    ? "text-primary-300"
                    : "#E6D9C2"
                }`}
              />
              <span>账户余额</span>
              <span className="text-text-secondary text-xs">
                可用额度：¥ {balance?.canUseBalance}
              </span>
            </Space>
            <RightOutlined />
          </div>
        )}

        {supportPays?.includes(PayType.ALIPAY) && (
          <div className={styles.item} onClick={() => setAliPayModalOpen(true)}>
            <Space>
              <AliPayIcon className={styles.icon} />
              支付宝支付
            </Space>
            <RightOutlined />
          </div>
        )}
        {supportPays?.includes(PayType.WECHAT) && (
          <div
            className={styles.item}
            onClick={() => setWechatPayModalOpen(true)}
          >
            <Space>
              <WeixinIcon className={styles.icon} />
              微信支付
            </Space>
            <RightOutlined />
          </div>
        )}
        {supportPays?.includes(PayType.OFFLINE) && (
          <div
            className={styles.item}
            onClick={() => setOfflineModalOpen(true)}
          >
            <Space>
              <BankIcon className={styles.icon} />
              线下汇款
            </Space>
            <RightOutlined />
          </div>
        )}
      </Modal>
      <BalancePayModal
        orderInfo={orderInfo}
        open={balancePayModalOpen}
        onClose={() => setBalancePayModalOpen(false)}
        onSuccess={() => onSuccess(PayType.BALANCE)}
        onSuccessPay={() => {
          setBalancePayModalOpen(false);
          onClose();
        }}
      />
      <OfflinePayModal
        open={offlineModalOpen}
        orderInfo={orderInfo}
        onClose={() => {
          setOfflineModalOpen(false);
        }}
        onSuccess={() => {
          setOfflineModalOpen(false);
          onSuccess(PayType.OFFLINE);
        }}
      />
      <WeChatPay
        open={wechatPayModalOpen}
        onClose={() => setWechatPayModalOpen(false)}
        onSuccess={() => {
          setWechatPayModalOpen(false);
          onSuccess(PayType.WECHAT);
        }}
        orderInfo={orderInfo}
      />
      <AliPay
        open={aliPayModalOpen}
        onClose={() => setAliPayModalOpen(false)}
        onSuccess={() => {
          setAliPayModalOpen(false);
          onSuccess(PayType.ALIPAY);
        }}
        orderInfo={orderInfo}
      />
    </>
  );
}
